import React from 'react';
import CustomButton from '../../../common/components/CustomButton';
import CustomSelect from '../../../common/components/CustomSelect';
import CustomTextInput from '../../../common/components/CustomTextInput';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

type MusicAlbumEditForm3EditPopupViewPerformanceRoleInputFieldName =
  ['music_performance_roles', number, 'role'|'name'|'name_en'];
type MusicAlbumEditForm3EditPopupViewPerformanceRoleInputItemName =
  'music_performance_roles';

/**
 * パフォーマンス入力
 */
export default function MusicAlbumEditForm3EditPopupViewPerformanceRoleInput({
  getNumberOfItems,
  addItem,
  getValue,
  setValue,
  getErrors,
  performanceRoleOptions,
} : {
  getNumberOfItems: (name: MusicAlbumEditForm3EditPopupViewPerformanceRoleInputItemName) => number,
  addItem: (name: MusicAlbumEditForm3EditPopupViewPerformanceRoleInputItemName, self: boolean) => void,
  getValue: (name: MusicAlbumEditForm3EditPopupViewPerformanceRoleInputFieldName) => string,
  setValue: (name: MusicAlbumEditForm3EditPopupViewPerformanceRoleInputFieldName, value: string) => void,
  getErrors: (name: MusicAlbumEditForm3EditPopupViewPerformanceRoleInputFieldName) => FieldValidationErrorsType,
  performanceRoleOptions: { title: string, value: string }[],
}) {
  return (
    <>
      { /* eslint-disable-next-line max-len */}
      {[...Array(getNumberOfItems('music_performance_roles')).keys()].map((index) => (
        <React.Fragment
          key={index} // eslint-disable-line react/no-array-index-key
        >
          <div className="parent_body mb-15">
            <span className="ttl_parent text-center">
              パフォーマンス
              {index + 1}
            </span>
            <dl>
              <dt>
                { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
                <label htmlFor="/">役割</label>
              </dt>
              <dd>
                <CustomSelect
                  options={performanceRoleOptions}
                  value={getValue(['music_performance_roles', index, 'role'])}
                  setValue={(value) => setValue(['music_performance_roles', index, 'role'], value)}
                  validationErrors={getErrors(['music_performance_roles', index, 'role'])}
                />
              </dd>
            </dl>
            <dl>
              <dt>
                { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
                <label htmlFor="/">名前</label>
              </dt>
              <dd>
                <CustomTextInput
                  placeholder="鈴木 太郎"
                  value={getValue(['music_performance_roles', index, 'name'])}
                  setValue={(value) => setValue(['music_performance_roles', index, 'name'], value)}
                  validationErrors={getErrors(['music_performance_roles', index, 'name'])}
                />
                <p className="text_info_off">ここに説明文</p>
              </dd>
            </dl>
            <dl>
              <dt>
                { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
                <label htmlFor="/">海外向け（英語またはローマ字）</label>
              </dt>
              <dd>
                <CustomTextInput
                  placeholder="Taro Suzuki"
                  value={getValue(['music_performance_roles', index, 'name_en'])}
                  setValue={(value) => setValue(['music_performance_roles', index, 'name_en'], value)}
                  validationErrors={getErrors(['music_performance_roles', index, 'name_en'])}
                />
                <p className="text_info_off">ここに説明文</p>
              </dd>
            </dl>
          </div>
        </React.Fragment>
      ))}
      {getNumberOfItems('music_performance_roles') < 3 && (
        <dl>
          <dd>
            <CustomButton type="add" onClick={() => addItem('music_performance_roles', false)}>
              <span>役割の追加</span>
            </CustomButton>
          </dd>
        </dl>
      )}
    </>
  );
}
